import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as XSvg } from '../../assets/x-icon.svg';

export const XIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={XSvg} {...props} />;
};
